import {Component, HostBinding, Input} from '@angular/core';

const componentBaseName = 'icon-symbol';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-icon-symbol',
  templateUrl: './icon-symbol.component.html',
})
export class IconSymbolComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() label: string;
  @Input() value: string;

  constructor() { }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/components/icon-symbol/icon-symbol.component.ts